import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MaterialPojectType } from "../../Types/HeyTraderTypes/Materials/MaterialPojectType";
import { getAllMaterialProjectList } from "../../Thunks/HeyTraderThunks";

interface MaterialProjectSliceState {
  loader: boolean; // for refres pages and inital loadings
  materialProjectList: MaterialPojectType[];
  errorDisplay: string | null;
}
// set inital valus
const initialState: MaterialProjectSliceState = {
  loader: false,
  materialProjectList: [],
  errorDisplay: '',
}

// set state valu for api response
const materialProjectSlice = createSlice({
  name: 'materialProject',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder.addCase(getAllMaterialProjectList.rejected, (state, action) => {
      state.loader = false;
      state.errorDisplay = action.error.message!;
    })
      .addCase(getAllMaterialProjectList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })
      .addCase(getAllMaterialProjectList.fulfilled, (state, action: PayloadAction<MaterialPojectType[]>) => {
        state.loader = false;
        state.materialProjectList = action.payload;
      })
  }
})

export const { } = materialProjectSlice.actions
export default materialProjectSlice.reducer

